import { env } from '@/env';

// Environment-scoped feature flags resolved from runtime config (config.js →
// window.__APP_CONFIG__, injected by entrypoint.sh) with a build-time fallback.
// Flags are UX-only and never a security boundary — anything here is visible in
// the browser, so any backed feature must also be enforced server-side.
//
// Add a flag: register VITE_FEATURE_FLAG_<NAME> in @/env, add it to the
// entrypoint.sh allow-list, then map it to a short semantic key below.
const featureFlags = {
  globalSearch: env.VITE_FEATURE_FLAG_GLOBAL_SEARCH,
  globalNotifications: env.VITE_FEATURE_FLAG_GLOBAL_NOTIFICATIONS,
} as const;

export type FeatureFlag = keyof typeof featureFlags;

// Read a flag inside a component. Flags are static for the lifetime of the app
// (resolved before first render), so this is a plain synchronous read — the hook
// shape is the seam where a live source could be swapped in later.
export function useFeatureFlag(flag: FeatureFlag): boolean {
  return featureFlags[flag];
}
